module.exports = __webpack_public_path__ + "img/outlandsthumb.9e198fa0.gif";